import type { Room } from "building-types/rooms/roomTypes";
import type { PolyLine2 } from "geom/polyLine2Types";

export interface WallIntervalStartEnd {
  readonly start: WallIntervalDatum;
  readonly end: WallIntervalDatum;
}

export interface WallInterval {
  readonly right: WallIntervalDatum;
  readonly left: WallIntervalDatum;

  readonly entities: {
    [key in WallIntervalEntityType]?: boolean;
  };

  readonly frontEntityIds: { [entityId: string]: boolean };
  readonly backEntityIds: { [entityId: string]: boolean };
}

export interface WallIntervalDatum {
  readonly param: number;
  readonly extentIds: { [entityId: string]: boolean };
}

export enum WallIntervalEntityType {
  WINDOW = "WINDOW",
  DOOR = "DOOR",
  DOOR_SWING = "DOOR_SWING",
  WALL_CUT = "WALL_CUT",
}

export type WallIntervalEntityTypes = {
  [key in WallIntervalEntityType]?: boolean;
};

export interface TraverseOptions {
  readonly ignoreEntityInterval?: boolean;
  readonly avoidDoors?: boolean;
  readonly avoidDoorSwings?: boolean;
  readonly avoidWindows?: boolean;
  readonly avoidWallCuts?: boolean;
  readonly stopAtNextDoor?: boolean;
  readonly perimeterTravelLimit?: number;
  readonly minimumIntervalWidth?: number;
  readonly placementIntervalWidth?: number;
}

export interface WallIntervalLoop {
  readonly intervals: WallInterval[][];
  readonly collinearJoinedVertices: number[];
}

export interface RoomEdgeBasedEntity {
  readonly type: "DOOR" | "DOOR_V2" | "WINDOW" | "WINDOW_V2";
  readonly id: string;
  readonly halfEdgeIndex: number;
  readonly frontRoom?: Room;
  readonly opening?: {
    readonly planExtents: PolyLine2;
  };
}

export interface PlanOutlineEntity {
  readonly id?: string;
  readonly opening?: {
    readonly planExtents: PolyLine2;
  };
}

export enum TraverseSide {
  FRONT = "FRONT",
  BACK = "BACK",
}

export enum TraverseDir {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}
